'use client'
import { FC, ReactNode } from 'react'
import { useGTMPageViewTracker } from 'storefront-modules/data-collection'

interface AppComponentProps {
  children: ReactNode
}

const AppComponent: FC<AppComponentProps> = ({ children }) => {
  useGTMPageViewTracker()

  return <>{children}</>
}

export default AppComponent
